// extracted by mini-css-extract-plugin
export default {"disclaimer":"style_disclaimer__ZEpVl"};